import React, { useState, useEffect } from 'react';
import './FacilityManagement.css';
import FacilityRow from '../FacilityRow/FacilityRow';
import InteractiveList from '../InteractiveList/InteractiveList';
import ListUpdateMessage from '../ListUpdateMessage/ListUpdateMessage';
import logComponent from '../../common/logComponent';

export default function FacilityManagement({ isLoading, isError, facilities, reload, showFacilityDetail, updatedFacility }) {
  const [lastMessageUpdate, setLastMessageUpdate] = useState(null);
  if (logComponent('FacilityManagement')) { console.debug('FacilityManagement rendered'); }


  useEffect(() => {
    if (logComponent('FacilityManagement')) { console.debug('FacilityManagement useEffect [updatedFacility]'); }
    setLastMessageUpdate(Date.now());
  }, [updatedFacility]);


  return (
    <div className="Facility-Management">
    {
      updatedFacility &&
      <ListUpdateMessage
        message={`${updatedFacility.name} logo has been updated.`}
        lastUpdate={ lastMessageUpdate } />
    }
      <InteractiveList  
        columns={[
          { name: 'Salesforce Site ID', sortField: 'SalesforceSiteId', hideAt: 'md-below', style: { width: '25%' } },
          { name: 'Name' },
          { name: 'Status' , style: { width: '25%' }, hideAt: 'sm' },
          { name: '', style: { width: '66px'}}
        ]}
        searchTextFields={['name','postalCode']}
        searchPlaceholder="Search facilities"
        defaultSortField="SalesforceSiteId"
        filters={[
          {
            title: 'Also uses',
            type: 'checkbox',
            name: 'servicesUsed',
            defaults: [],
            options: [
              {
                text: 'SARA',
                criteria: [{
                  field: 'UsingSara',
                  acceptedValues: [true]
                }]
              },
              {
                text: 'CATIE',
                criteria: [{
                  field: 'UsingCatie',
                  acceptedValues: [true]
                }]
              },             {
                text: 'eMessenger',
                criteria: [{
                  field: 'UsingEMessenger',
                  acceptedValues: [true]
                }]
              }
            ]
          },
          {
            title: 'Industry type',
            type: 'checkbox',
            name: 'industryType',
            options: [
              {
                text: 'CCRC',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['CCRC']
                }]
              },
              {
                text: 'Long Term Care',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Long Term Care']
                }]
              },
              {
                text: 'Healthcare',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Healthcare']
                }]
              },
              {
                text: 'Hotel/Hospitality',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Hotel/Hospitality']
                }]
              }, 
              {
                text: 'Government',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Government']
                }]
              },
              {
                text: 'Education',
                criteria: [{
                  field: 'IndustryType',
                  acceptedValues: ['Education']
                }]
              }
            ]
          }
          /* TODO: Uncomment Status filter once data is available ,
          {
            title: 'Status',
            type: 'checkbox',
            name: 'status',
            options: [
              {
                text: 'Active',
                criteria: []
              }, {
                text: 'Inactive',
                criteria: []
              }
            ]
          } */           
        ]}                      
        singularItemTerm="facility"
        pluralItemTerm="facilities"
        items={facilities}
        itemsLoading={isLoading}
        itemsError={isError}
        rowComponent={FacilityRow}
        showDetail={showFacilityDetail}
        keyField="salesforceAccountId"
        reloadAction={reload}
      />
    </div>
  );
}